import { Helmet } from "react-helmet";
import PageHero from "../components/reusables/hero/PageHero";
import PrivacyPolicyBody from "../components/privacy-policy/PrivacyPolicyBody";

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/privacy-policy"
        />
        <meta
          name="description"
          content="Learn how NTUNA.COM collects, uses and protects your shared information in accordance with our commitment to privacy and data security."
        />
        
        <meta
          property="og:description"
          content="Learn how NTUNA.COM collects, uses and protects your shared information in accordance with our commitment to privacy and data security."
        />
        <meta property="og:title" content="NTUNA.COM | Privacy Policy" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta name="twitter:title" content="NTUNA.COM | Privacy Policy" />
        <meta name="twitter:text:title" content="NTUNA.COM | Privacy Policy" />
        <meta
          name="twitter:description"
          content="Learn how NTUNA.COM collects, uses and protects your shared information in accordance with our commitment to privacy and data security."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM | Privacy Policy</title>
      </Helmet>
      <PageHero
        classes="world-bg"
        titleClasses="title uppercase ntuna-text-fill"
        title="Privacy Policy"
      />
      <PrivacyPolicyBody />
    </>
  );
}
